// Convert Hex colour to rgba
// Lottie JSON doesn't work with hex colours
export function hex2rgba(hex: string, alpha = 1) {
  if (!hex) return "";
  // TODO Fix TS
  //@ts-ignore
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
}
